import {
	colorPalette,
	fontSize,
	fontWeight,
	mainLinks,
	supporter,
	fontFamily,
} from '../../config';
import {
	participateLogoImg,
	recogLogoImg,
	infoLogoImg,
	recordLogoImg,
	notifyLogoImg,
	support1,
	support2,
	cbsImg,
	gyeongSangImg,
	jinjuImg,
	courseMainImg,
	marathoninfo,
} from '../../config/images';

const dateTextProps = {
	title: {
		fontSize: {
			desktop: '25px',
			tablet: '25px',
			mobile: '24px',
		},
		color: colorPalette.white,
		fontWeight: fontWeight.bold,
		shadow: `0 0 5px rgba(0, 0, 0, 0.7);`,
	},
	unit: {
		fontSize: {
			desktop: '25px',
			tablet: '22px',
			mobile: '20px',
		},
		color: colorPalette.white,
		fontWeight: fontWeight.bold,

		shadow: `0 0 5px rgba(0, 0, 0, 0.7);`,
	},
	value: {
		fontSize: {
			desktop: '40px',
			tablet: '38px',
			mobile: '30px',
		},
		color: colorPalette.white,
		fontWeight: fontWeight.bold,
		shadow: `0 0 5px rgba(0, 0, 0, 0.7);`,
	},
};

export const firstProps = {
	// minititle: {
	// 	type: 'p',
	// 	children: `2025`,
	// 	fontSize: {
	// 		desktop: '24px',
	// 		tablet: '24px',
	// 		mobile: '15px',
	// 	},
	// 	fontFamily: 'Pretendard',
	// 	color: colorPalette.warn,
	// 	fontWeight: fontWeight.bold,
	// 	marginBotton: '12px',
	// },

	imgs: [{src: marathoninfo}],

	title: {
		type: 'p',
		children: `제 2회 10.19 평화마라톤`,
		fontSize: {
			//desktop: fontSize.xl10,
			desktop: '71px',
			tablet: '36px',
			mobile: '36px',
		},
		fontFamily: 'Gmarket',
		color: colorPalette.yeosumain,
		fontWeight: fontWeight.extraBold,
		marginBotton: '13px',
	},
	content: {
		type: 'p',
		children: `2026.10.17 (토) 09:00 출발`,
		fontSize: {
			desktop: fontSize.xl5,
			tablet: '35px',
			mobile: '18px',
		},
		color: colorPalette.yeosumain,
		fontWeight: fontWeight.bold,
		fontFamily: 'Gmarket',
	},
	button: {
		text: {
			children: '신청하기',
			fontSize: {
				desktop: '24px',
				tablet: '24px',
				mobile: '16px',
			},
			lineHeight: 2.2,
			color: colorPalette.white,
			fontWeight: fontWeight.medium,
			fontFamily: 'Pretendard',
		},
		onClick: () =>
			(window.location.href = `${window.location.origin}/participation/person`),
		isRounded: true,
		bgColor: colorPalette.primary,
	},
	date: {
		title: {...dateTextProps.title, children: '행사 시작까지'},
		day: {...dateTextProps.unit, children: 'DAY'},
		dayValue: {...dateTextProps.value, children: '14'},
		hour: {...dateTextProps.unit, children: 'HOUR'},
		hourValue: {...dateTextProps.value, children: '8'},
		minute: {...dateTextProps.unit, children: 'MINUTES'},
		minuteValue: {...dateTextProps.value, children: '25'},
		second: {...dateTextProps.unit, children: 'SECONDS'},
		secondValue: {...dateTextProps.value, children: '32'},
	},
};

const secondTextProps = {
	title: {
		fontSize: {
			desktop: '26px',
			tablet: '26px',
			mobile: '26px',
		},
		color: colorPalette.white,
		fontWeight: fontWeight.medium,
		fontFamily: 'Gmarket',
	},
	content: {
		fontSize: {
			desktop: '16px',
			tablet: '16px',
			mobile: '16px',
		},
		color: colorPalette.white,
		fontWeight: fontWeight.base,
		fontFamily: 'Gmarket',
	},
	support: {
		fontSize: {
			desktop: fontSize.xl2,
			tablet: '22px',
			mobile: '15px',
		},
		color: colorPalette.base,
		fontWeight: fontWeight.semiBold,
	},
};

export const secondProps = {
	info: {
		title: {
			...secondTextProps.title,
			children: '마라톤 알아보기',
		},
		content: {
			...secondTextProps.content,
			children: `마라톤에 도움이 되는 바로가기\n정보를 안내합니다.`,
		},
		links: mainLinks,
	},
	supports: supporter,
};

export const thirdTextProps = {
	title: {
		fontSize: {
			desktop: fontSize.xl3,
			tablet: '36px',
			mobile: '26px',
		},
		fontWeight: fontWeight.medium,
		color: colorPalette.white,
		fontFamily: 'Gmarket',
	},
	description: {
		fontSize: {
			desktop: '16px',
			tablet: '16px',
			mobile: '16px',
		},
		fontWeight: fontWeight.medium,
		color: colorPalette.white,
	},
	item: {
		title: {
			fontSize: {
				desktop: '20px',
				tablet: '20px',
				mobile: '18px',
			},
			color: colorPalette.accent,
			fontWeight: fontWeight.bold,
			lineHeight: '30px',
		},
		content: {
			fontSize: {
				desktop: '20px',
				tablet: '20px',
				mobile: '16px',
			},
			color: colorPalette.white,
			fontWeight: fontWeight.normal,
			lineHeight: '30px',
		},
		smalContent: {
			fontSize: {
				desktop: fontSize.base,
				tablet: '16px',
				mobile: '16px',
			},
			color: colorPalette.accent,
			fontWeight: fontWeight.medium,
		},
		accentContent: {
			fontSize: {
				desktop: '20px',
				tablet: '20px',
				mobile: '16px',
			},
			color: colorPalette.accent,
			fontWeight: fontWeight.normal,
			lineHeight: '30px',
		},
		accentRedContent: {
			fontSize: {
				desktop: '20px',
				tablet: '20px',
				mobile: '16px',
			},
			color: colorPalette.accent,
			fontWeight: fontWeight.bold,
			lineHeight: '30px',
		},
	},
};

export const thirdProps = {
	title: {
		textAlign: 'left',
		// bgColor: colorPalette.white,
		height: '3px',
		text: {...thirdTextProps.title, children: '대회요강', type: 'p'},
		description: {
			...thirdTextProps.description,
			children: '반드시 참가 유의사항을 읽고 신청해주세요.',
		},
	},
	first: [
		{
			title: {...thirdTextProps.item.title, children: '대회명'},
			contents: [
				{
					...thirdTextProps.item.content,
					children: `제 2회 10.19 평화마라톤`,
				},
			],
		},
		{
			title: {...thirdTextProps.item.title, children: '대회일시'},
			contents: [
				{
					...thirdTextProps.item.title,
					children: `2026년 10월 17일 (토) 09:00 출발`,
				},
				// {
				// 	...thirdTextProps.item.content,
				// 	children: `10.19km 3조 / 5km 2조`,
				// },
			],
		},
		{
			title: {...thirdTextProps.item.title, children: '출발시간'},
			contents: [
				{
					...thirdTextProps.item.content,
					children: `10.19km 09:00\n5km 09:10`,
				},
			],
		},
		{
			title: {...thirdTextProps.item.title, children: '접수기간'},
			contents: [
				{
					...thirdTextProps.item.title,
					children: `2026년 9월 20일(일) 24:00까지 \n(선착순 3,000명 조기마감 될 수 있습니다.)`,
				},
			],
		},
		// {
		// 	title: {...thirdTextProps.item.title, children: '기념품\n배부시간'},
		// 	contents: [
		// 		{
		// 			...thirdTextProps.item.title,
		// 			children: `-`,
		// 		},
		// 		{
		// 			...thirdTextProps.item.content,
		// 			children: `*대회 시작 전 기념품을 배부합니다.`,
		// 		},
		// 	],
		// },
		{
			title: {...thirdTextProps.item.title, children: '장소'},
			contents: [
				{
					...thirdTextProps.item.content,
					children: `여수 진남경기장 주경기장`,
				},
			],
		},
		{
			title: {...thirdTextProps.item.title, children: '참가구분'},
			contents: [
				{
					...thirdTextProps.item.content,
					children: `10.19km/5km`,
				},
				{
					...thirdTextProps.item.content,
					children: `2가지 코스 중 선택 가능`,
				},
			],
		},
		{
			title: {...thirdTextProps.item.title, children: '모집인원'},
			contents: [
				{
					...thirdTextProps.item.accentRedContent,
					children: `선착순 3,000명\n*접수 마감일 전 조기 마감 될 수 있습니다.`,
				},
			],
		},
	],
	second: [
		{
			title: {...thirdTextProps.item.title, children: '참가자격'},
			contents: [
				{
					...thirdTextProps.item.content,
					children: `나이제한 없으며, 신체 건강한 남 / 녀`,
				},
				{
					...thirdTextProps.item.content,
					children: `장소와 주로가 협소하므로 안전을 위해 부득이하게 휠체어, 유모차, 애견동반이 금지됩니다.`,
				},
				{
					...thirdTextProps.item.smalContent,
					children: `대한육상경기연맹 등록선수 및 선수등록 말소 후\n2년 경과되지 않은 자는 시상에서 제외됩니다.`,
				},
			],
		},
		{
			title: {...thirdTextProps.item.title, children: '접수방법'},
			contents: [
				{
					...thirdTextProps.item.content,
					children: `인터넷으로만 접수`,
				},
			],
		},
		{
			title: {...thirdTextProps.item.title, children: '참가비'},
			contents: [
				{
					...thirdTextProps.item.content,
					children: `10.19km코스 - 35,000원\n5km코스 - 20,000원`,
				},
			],
		},
		{
			title: {...thirdTextProps.item.title, children: '입금계좌'},
			contents: [
				{
					...thirdTextProps.item.content,
					children: `농협 301-0299-6156-41\n 주식회사 뉴스탑전남\n\n접수기간 내 환불요청 시 참가비 10%를 제외한 금액 환불. 자세한 사항은 유의사항 확인`,
				},
			],
		},
	],
};

const fourthTextProps = {
	title: {
		fontSize: {
			desktop: fontSize.xl3,
			tablet: '36px',
			mobile: '24px',
		},
		fontWeight: fontWeight.medium,
		color: colorPalette.white,
		fontFamily: 'Gmarket',
	},
	description: {
		fontSize: {
			desktop: '16px',
			tablet: '16px',
			mobile: ' 16px',
		},
		fontWeight: fontWeight.medium,
		color: colorPalette.white,
	},
};

export const fourthProps = {
	title: {
		textAlign: 'left',
		bgColor: colorPalette.primary,
		height: '5px',
		text: {...fourthTextProps.title, children: '대회코스', type: 'p'},
		description: {
			...fourthTextProps.description,
			children: '대회 구간을 참고하시고 신청 바랍니다',
		},
	},
	course: {
		src: courseMainImg,
		alt: '코스',
		borderRadius: '1.375rem',
	},
};

export const modalProps = {
	isClose: true,
	imgs: [{src: courseMainImg}, {src: ''}],
};
export const fifthProps = {};
